"use client";
import type { MapBlockDoc as MapBlockTypes } from "../../types/blocks";
import dynamic from "next/dynamic";
import { useMemo } from "react";

const MapBlock: React.FC<MapBlockTypes> = (props) => {
  const Map = useMemo(() => {
    return dynamic(() => import("../../ui/LeafletMap"), {
      loading: () => <p>A map is loading</p>,
      ssr: false,
    });
  }, []);
  return (
    <div>
      <Map longitude={props.longitude} latitude={props.latitude} />
    </div>
  );
};

export { MapBlock };
